import PropTypes from "prop-types";
import { Link, useNavigate, useLocation } from "react-router-dom";
import { useSelector } from "react-redux";
import { useEffect, useState } from "react";
import clsx from "clsx";
import MenuCart from "./sub-components/MenuCart";
import { useTranslation } from "react-i18next";
import { jwtDecode } from "jwt-decode";
import { getUserFromToken } from "../../services/User";
import { getCartItems } from "../../services/Cart";
import { getWishlistItems } from "../../services/wishlist";
import { getToken, removeToken } from "../../services/AuthStorage";
import { clearVoucherFromLocal } from "../../services/Voucher";
const IconGroup = ({ iconWhiteClass }) => {
  const { t } = useTranslation();
  const navigate = useNavigate();
  const [isLoggedIn, setIsLoggedIn] = useState(false);
  const [username, setUsername] = useState("");
  const [cartCount, setCartCount] = useState(0);
  const [wishlistCount, setWishlistCount] = useState(0);
  const location = useLocation();
  const hideCartMini = location.pathname === "/checkout";
  const updateCartCount = async () => {
    try {
      const cartItems = await getCartItems(); // tự xử lý user/guest
      const totalQuantity = cartItems.reduce(
        (total, item) => total + item.quantity,
        0
      );
      setCartCount(totalQuantity);
    } catch (error) {
      console.error("Error fetching cart count:", error);
      setCartCount(0);
    }
  };

  const updateWishlistCount = async () => {
    try {
      const wishlistItems = await getWishlistItems();
      setWishlistCount(wishlistItems.length || 0);
    } catch (error) {
      console.error("Error fetching wishlist:", error);
      setWishlistCount(0);
    }
  };

  const isAuthenticated = () => {
    const token = getToken();
    if (!token) return false;
  
    try {
      const { exp } = jwtDecode(token);
      const now = Math.floor(Date.now() / 1000);
  
      if (!exp || exp < now) {
        removeToken(); // ✅ Nếu token hết hạn thì tự động xoá luôn
        clearVoucherFromLocal();
        localStorage.removeItem("checkoutForm");
        return false;
      }
  
      return true;
    } catch (error) {
      console.error("Invalid token:", error);
      removeToken(); // ✅ Nếu token decode lỗi cũng xoá
      clearVoucherFromLocal();
      localStorage.removeItem("checkoutForm");
      return false;
    }
  };
  

  const checkAuth = async () => {
    const auth = isAuthenticated();
    setIsLoggedIn(auth);

    if (auth) {
      const user = getUserFromToken();
      if (user) {
        setUsername(user.unique_name);
      }
    } else {
      setUsername("");
    }

    await updateCartCount();
    await updateWishlistCount();
  };

  useEffect(() => {
    checkAuth();

    const handleStorageChange = (e) => {
      if (e.key === "token" || e.key === null) {
        checkAuth();
      }
    };

    window.addEventListener("storage", handleStorageChange);
    window.addEventListener("storage-event", checkAuth);
    window.addEventListener("cart-updated", updateCartCount);
    window.addEventListener("wishlist-updated", updateWishlistCount);
    return () => {
      window.removeEventListener("storage", handleStorageChange);
      window.removeEventListener("storage-event", checkAuth);
      window.removeEventListener("cart-updated", updateCartCount);
      window.removeEventListener("wishlist-updated", updateWishlistCount);
    };
  }, []);

  const handleClick = (e) => {
    const target = e.currentTarget.nextSibling;
    if (target) {
      target.classList.toggle("active");

      // Nếu cart được mở ra thì dispatch sự kiện
      if (
        target.classList.contains("shopping-cart-content") &&
        target.classList.contains("active")
      ) {
        window.dispatchEvent(new CustomEvent("cart-opened"));
      }
    }
  };

  const handleLogout = () => {
    removeToken(); // Xoá cả localStorage và sessionStorage token
    clearVoucherFromLocal();
    localStorage.removeItem("checkoutForm");
    setIsLoggedIn(false);
    setUsername("");
    document.querySelector(".account-dropdown")?.classList.remove("active");
    navigate("/");
  };

  const triggerMobileMenu = () => {
    const offcanvasMobileMenu = document.querySelector(
      "#offcanvas-mobile-menu"
    );
    offcanvasMobileMenu.classList.add("active");
  };

  // const { compareItems } = useSelector((state) => state.compare);
  // const { wishlistItems } = useSelector((state) => state.wishlist);

  return (
    <div className={clsx("header-right-wrap", iconWhiteClass)}>
      <div className="same-style header-search d-none d-lg-block">
        <button className="search-active" onClick={(e) => handleClick(e)}>
          <i className="pe-7s-search" />
        </button>
        <div className="search-content">
          <form action="#">
            <input type="text" placeholder={t("search")} />
            <button className="button-search">
              <i className="pe-7s-search" />
            </button>
          </form>
        </div>
      </div>
      <div className="same-style account-setting d-none d-lg-block">
        <button
          className="account-setting-active"
          onClick={(e) => handleClick(e)}
        >
          <i className="pe-7s-user-female" />
        </button>
        <div className="account-dropdown">
          <ul>
            {isLoggedIn ? (
              // Show these options when user is logged in
              <>
                <li className="username-display">
                  <span>{t("hello")},</span>
                  <span className="username">{username}</span>
                </li>
                <li>
                  <Link to={process.env.PUBLIC_URL + "/my-account"}>
                    {t("myAccount")}
                  </Link>
                </li>
                <li>
                  <Link to={process.env.PUBLIC_URL + "/my-orders"}>
                    {t("myOrders")}
                  </Link>
                </li>
                <li>
                  <Link
                    to={process.env.PUBLIC_URL + "/login-register"}
                    onClick={handleLogout}
                  >
                    {t("logout")}
                  </Link>
                </li>
              </>
            ) : (
              // Show these options when user is not logged in
              <>
                <li>
                  <Link to={process.env.PUBLIC_URL + "/login-register"}>
                    {t("login")}
                  </Link>
                </li>
                <li>
                  <Link to={process.env.PUBLIC_URL + "/login-register"}>
                    {t("register")}
                  </Link>
                </li>
              </>
            )}
          </ul>
        </div>
      </div>
      {/* <div className="same-style header-compare">
        <Link to={process.env.PUBLIC_URL + "/compare"}>
          <i className="pe-7s-shuffle" />
          <span className="count-style">{compareCount}</span>
        </Link>
      </div> */}
      <div className="same-style header-wishlist">
        <Link to={process.env.PUBLIC_URL + "/wishlist"}>
          <i className="pe-7s-like" />
          <span className="count-style">{wishlistCount}</span>
        </Link>
      </div>
      {!hideCartMini && (
        <div className="same-style cart-wrap d-none d-lg-block">
          <button className="icon-cart" onClick={(e) => handleClick(e)}>
            <i className="pe-7s-shopbag" />
            <span className="count-style">{cartCount}</span>
          </button>
          {/* menu cart */}
          <MenuCart />
        </div>
      )}
      <div className="same-style cart-wrap d-block d-lg-none">
        <Link className="icon-cart" to={process.env.PUBLIC_URL + "/cart"}>
          <i className="pe-7s-shopbag" />
          <span className="count-style">{cartCount}</span>
        </Link>
      </div>
      <div className="same-style mobile-off-canvas d-block d-lg-none">
        <button
          className="mobile-aside-button"
          onClick={() => triggerMobileMenu()}
        >
          <i className="pe-7s-menu" />
        </button>
      </div>
    </div>
  );
};

IconGroup.propTypes = {
  iconWhiteClass: PropTypes.string,
};

export default IconGroup;
